import React from 'react'
import { Container } from 'reactstrap';

import UpdateProviderContainer from '../../provider/containers/UpdateProviderContainer'

class UpdateProfile extends React.Component {

    render() {
    	const { user } = this.props

    	return (
             <Container className="page-provider-update">
                <UpdateProviderContainer provider_id={user.provider} />
            </Container>
        )
    }
}


export default UpdateProfile



// WEBPACK FOOTER //
// ./src/btoc/components/UpdateProfile.js